import * as pbi from '../services/pbi';

export default {
  namespace: 'pbi',

  state: {
    embedData: null,
  },

  effects: {
    *getEmbedData({ payload: { values }, callback }, { call, put }) {
      const response = yield call(pbi.getEmbedData, values);
      yield put({
        type: 'save',
        payload: {
          embedData: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
